import {AuthComponent} from "./auth.component";

export default AuthComponent
